var map = {
	"./authors/gregg.jpg": 5900,
	"./authors/joy.jpg": 316,
	"./avatar.png": 8987,
	"./avatar_lottie": 5515,
	"./avatar_lottie.json": 5515,
	"./banners/how-to-use-smartcharts.png": 8162,
	"./banners/learn-forex.png": 6952,
	"./banners/learn-the-basics.png": 7919,
	"./banners/lxf-webinars.png": 7689,
	"./banners/psychology-of-trading.png": 6443,
	"./banners/stock-indices.png": 2668,
	"./banners/whats-new.png": 6561,
	"./card-bg.png": 1049,
	"./how-to-use-smartcharts.png": 4733,
	"./learn-forex.png": 6455,
	"./learn-the-basics.png": 2411,
	"./logo.png": 4427,
	"./lxf-webinars.png": 8248,
	"./stock-indices.png": 9704,
	"./test-icon.svg": 3655,
	"./whats-new.png": 9834
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;